import { AbstractOperationMessage } from "./abstractOperationMessage"

export class DataSelectorOperationMessage extends AbstractOperationMessage {
  
}